
// @ts-check

import React from "react";

import CampaignList, { getQueryName } from "./CampaignList";

// @ts-ignore
import xIcon from "../images/remove_search.svg";

import "../styles/ChooseCampaignLightbox.css";

import FocusTrap from "focus-trap-react"

/**
 * @typedef {import('./coreTypes').CampaignObject} CampaignObject
 */

/**
 * @param {{ 
 *    cancelLightbox: () => void,
 *    selectCampaign: (a: string) => void, }} props 
 * @returns {JSX.Element | null}
 */

function ChooseCampaignLightbox(props) {

    return (
        <FocusTrap>
        {/** @ts-ignore */}
        <div style={outsideLightboxStyle} onClick={props.cancelLightbox}>
            {/** @ts-ignore */}
            <div className="choose-campaign-lightbox" style={lightBoxContainerStyle} onClick={e => { e.stopPropagation(); }}>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40, }}>
                    <div className="campaign-card-list__section">
                        <h2 className="campaign-card-list__title">Browse By Campaign</h2>
                        <div className="campaign-card-list__container">
                            <table className="campaign-card-list__container__table">
                                {buildCampaignTableBody(props.cancelLightbox, props.selectCampaign)}
                            </table>
                        </div>
                    </div>
                </div>

                <img src={xIcon} aria-label="Close Popup" alt="Cancel" className="choose-campaign-lightbox__x-btn" 
                        onKeyDown={ (event) => {
                             if (event.key === "Enter") {
                                 props.cancelLightbox();
                                } 
                            }
                        } 

                        onClick={props.cancelLightbox} tabIndex={ 0 }/>

            </div>      
        </div>
        </FocusTrap>
    );
};

const outsideLightboxStyle = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.8)',
    zIndex: '10',
    overflowY: 'scroll',
};

const lightBoxContainerStyle = {
    width: '55%',
    backgroundColor: 'white',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 130,
    fontColor: 'white',
    display: 'flex',
    flexDirection: 'column',
};

/**
 * @param { () => void } cancelLightbox
 * @param {(a: string) => void } selectCampaign
 * @returns {JSX.Element}
 */
function buildCampaignTableBody(cancelLightbox, selectCampaign) {
    const campaignCards =
        CampaignList.map(c => (
                <div className="campaign-card__container" tabIndex={ 0 } role={ "link" }
                    onKeyDown={ (event) => {
                        // keyboard support for campaign items
                        if (event.key === "Enter") {
                            selectCampaign(getQueryName(c)); 
                            cancelLightbox();
                        }
                         } }
                    onClick={() => { 
                        selectCampaign(getQueryName(c)); 
                        cancelLightbox();
                        }}>
                    <label className="campaign-card__label">{c.title}</label>
                    <img className="campaign-card__image" src={c.image.browse.url} alt={c.title} />
                </div>
            ));

    const campaignCardsTable = [];

    let lastIndex = 0;
    for (let i = 0; i < campaignCards.length+3; i += 3)
    {
        campaignCardsTable.push(
            (<tr>
                <td>
                    {campaignCards[i]}
                </td>
                <td>
                    {campaignCards[i+1]}
                </td>
                <td>
                    {campaignCards[i+2]}
                </td>                
            </tr>)
        );
        lastIndex = i+2;
    }

    const remaining = campaignCards.length - lastIndex;

    switch (remaining) {
        case 2:
            campaignCardsTable.push(
                (<tr>
                    <td>
                        {campaignCards[lastIndex]}
                    </td>
                    <td>
                        {campaignCards[lastIndex+1]}
                    </td>      
                </tr>)
            );
            break;
        case 1:
            campaignCardsTable.push(
                (<tr>
                    <td>
                        {campaignCards[lastIndex]}
                    </td>             
                </tr>)
            );
            break;
        default: 
            break;
    }

    return ( 
        <tbody>
            {campaignCardsTable}
        </tbody>);
}

export default ChooseCampaignLightbox;
